import React from "react";
import '../../../sass/components/flexibleModules/_components.performTicketSectionComponent.scss';
import iconPatternThree from '../../../images/perform-2023-pattern3.svg';
import iconPatternFour from '../../../images/perform-2023-pattern4.svg';
import iconPatternFive from '../../../images/perform-2023-pattern5.svg';

const Perform2023TicketsSection = ({ data }) => {
    return (
        <div className="cp-ticketOffersSection">
            <div className="l--absolute l-absoluteThree">
                <img src={iconPatternThree} alt="" />
            </div>
            <div className="l--absolute l-absoluteFour">
                <img src={iconPatternFour} alt="" />
            </div>
            <div className="l--absolute l-absoluteFive">
                <img src={iconPatternFive} alt="" />
            </div>
            <div className="cp-ticketOffersSection__inner" data-aos="fade-up">
                <div className="cp-ticketOffersSection__inner-left">
                    {data.performTicketSection &&
                        <h2>{data.performTicketSection}</h2>
                    }
                    {data.performTicketSectionTeaser &&
                        <p dangerouslySetInnerHTML={{ __html: data.performTicketSectionTeaser }} />
                    }
                </div>
                <div className="cp-ticketOffersSection__inner-right">
                    {data.performTicketSectionOffers &&
                        <>
                            {data.performTicketSectionOffers.map((ticketOffer, index) => (
                                <div className={`cp-ticketOffers l-flex l-disable${ticketOffer.enableCheck}`} key={index}>
                                    <div className="cp-ticketOffers__left">
                                        {ticketOffer.offerName &&
                                            <h3 dangerouslySetInnerHTML={{ __html: ticketOffer.offerName }} />
                                        }
                                        {ticketOffer.offerTeaser &&
                                            <span dangerouslySetInnerHTML={{ __html: ticketOffer.offerTeaser }} />
                                        }
                                    </div>
                                    <div className="cp-ticketOffers__right">
                                        {ticketOffer.offerPrice &&
                                            <span className="l-price" dangerouslySetInnerHTML={{ __html: ticketOffer.offerPrice }} />
                                        }
                                        {ticketOffer.offerLink &&
                                            <a href={ticketOffer.offerLink.url} target={ticketOffer.offerLink.target} className="l-button">{ticketOffer.offerLink.title}</a>
                                        }
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default Perform2023TicketsSection;